import angular from 'angular';

import '../../services/employee';
import '../../services/media';

angular.module("folkeuni").component("employeeRelatedProducts", {
    bindings: {
        siteId: "@",
        employeeId: "@"
    },
    controller: function (Employee, Media, $timeout) {
        var $ctrl = this;
        $ctrl.productsThisSeason = null;

        $ctrl.$onInit = function () {
            Employee.relatedProductsGet($ctrl.siteId, $ctrl.employeeId).then(
                function (products) {
                    $ctrl.productsThisSeason = products;

                    $timeout(function () {
                        var queryString = "id:";

                        for (var i = 0; i < $ctrl.productsThisSeason.length; i++) {
                            var currentProduct = $ctrl.productsThisSeason[i];

                            if (i > 0) {
                                queryString += " OR ";
                            }
                            queryString += currentProduct.imageId;
                        }

                        var imageSearchQuery = { query: queryString, take: 1000 };

                        Media.searchImages(imageSearchQuery).then(function (imgResponse) {
                            for (var i in $ctrl.productsThisSeason) {
                                var currentProduct = $ctrl.productsThisSeason[i];

                                for (var y in imgResponse) {
                                    var currentImage = imgResponse[y];
                                    if (typeof currentImage !== "undefined" && currentImage != null) {
                                        if (currentImage.id == currentProduct.imageId) {
                                            currentProduct.imageObj = currentImage;

                                            $ctrl.productsThisSeason[i].productImageUrl = Media.buildCropUrl(
                                                currentImage,
                                                "1:1(Small)"
                                            );
                                        }
                                    }
                                }
                            }
                        });
                    }, 10);
                },
                function () {}
            );
        };
    },
    templateUrl: "/shop-dist/templates/employee-related-products.html"
});